/* @flow */
import React from 'react';
import Activity from 'entities/Activity';
import ActivityList from 'payments/components/ActivityList.jsx';
import ActivityListCard from 'payments/components/ActivityListCard.jsx';
import ActivitiesTabNux from 'payments/components/ActivitiesTabNux.jsx';
import ActivitiesNotificationsContainer from 'payments/containers/ActivitiesNotificationsContainer.jsx';

import './styles/ActivitiesSplitView.scss';

const NUMBER_OF_PAST_ACTIVITIES = 5;

// typecheck: ignore statement
function split(activities: Activity[]): {upcoming: Activity[], past: Activity[]} {
  const upcoming = [];
  const past = [];
  const today = new Date();

  activities.forEach(activity => {
    const startAt = activity.getStartAt();
    startAt && startAt > today && !activity.isClosed() ? // eslint-disable-line
      upcoming.push(activity) :
      past.push(activity);
  });

  return { upcoming, past };
}

type Props = {
  activities: Activity[],
  nuxCanManage: boolean,
};

class ActivitiesSplitView extends React.Component {
  props: Props;

  render() {
    const { upcoming, past } = split(this.props.activities);
    const pastToShow = past.slice(0, NUMBER_OF_PAST_ACTIVITIES);

    // Forgive me,
    // the activity list is a list containing activity card,
    // the activity list card is a card containing an activity list.
    // Q.
    return (
      <div className="ActivitiesSplitView">
        {upcoming.length > 0 &&
          <div className="ActivitiesSplitView-list">
            <ActivityList activities={upcoming} />
          </div>
        }

        {upcoming.length === 0 &&
          <div className="ActivitiesSplitView-list">
            <ActivitiesTabNux hideImage canManage={this.props.nuxCanManage} />
          </div>
        }

        <div className="ActivitiesSplitView-side">
          <ActivitiesNotificationsContainer data-test="activities-notifications-container" />
          {pastToShow.length > 0 &&
            <ActivityListCard title="Past activities" activities={pastToShow} />
          }
        </div>
      </div>
    );
  }
}

export default ActivitiesSplitView;



// WEBPACK FOOTER //
// ./src/payments/components/ActivitiesSplitView.jsx